import React from 'react';

const AssignTripsPage = React.lazy(() => import('./assign-trips/AssignTripsPage'));
const AssignTripToDriverPage = React.lazy(() => import('./assign-trips/AssignTripsToDriverPage'));
const CurrentTripsPage = React.lazy(() => import('./current-trips/CurrentTripsPage'));
const ArchiveTripsPage = React.lazy(() => import('./archive-trips/ArchiveTripsPage'));

const TripsPageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },

  routes: [
    {
      path: 'trips/assign-trips',
      element: <AssignTripsPage />,
      auth: null,
    },
    {
      path: 'trips/assign-trips/:id',
      element: <AssignTripToDriverPage />,
      auth: null,
    },
    {
      path: 'trips/current-trips',
      element: <CurrentTripsPage />,
      auth: null,
    },
    {
      path: 'trips/archive-trips',
      element: <ArchiveTripsPage />,
      auth: null,
    },
    // {
    //   path: 'trips/new-vehicle',
    //   element: <AssignTripsPage />,
    // },
    // {
    //   path: 'trips/define-transport',
    //   element: <AssignTripsPage />,
    // },
  ],
};

export default TripsPageConfig;
